<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>액션 시민 추가</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sch_condition_wrap">
            <div class="select_tab_box _130">
                <div class="selected_tab" :class="[state.isShowSearchType ? 'active' : '']" @click="state.isShowSearchType = !state.isShowSearchType">
                    <span>{{ state.detailTxt }}</span>
                </div>
                <div class="tab_option" v-show="state.isShowSearchType" :class="[state.isShowSearchType ? 'active' : '']">
                    <button
                        v-for="item in search_type_list"
                        :key="item.key"
                        @click="
                            state.searchType = item.key;
                            state.detailTxt = item.value;
                            state.isShowSearchType = false;
                            if (item.key === 'all' || item.value === '전체') {
                                state.currentPage = 1;
                                getList();
                            }
                        "
                    >
                        {{ item.value }}
                    </button>
                </div>
            </div>

            <div>
                <template v-if="state.searchType == 'gender' || state.searchType == '3' || state.searchType == '성별'">
                    <select
                        class="gender_select"
                        v-model="state.searchText"
                        @change="
                            state.currentPage = 1;
                            getList();
                        "
                    >
                        <option value="">전체</option>
                        <option value="M">남자</option>
                        <option value="F">여자</option>
                        <option value="E">기타</option>
                    </select>
                </template>

                <template v-else>
                    <div class="search_wrap input_wrap" style="display: flex; align-items: center">
                        <input
                            type="text"
                            v-model="state.searchText"
                            @keyup.enter="
                                state.currentPage = 1;
                                getList();
                            "
                            placeholder="검색어를 입력하세요."
                        />
                        <button
                            type="button"
                            class="search_btn icon_wrap"
                            @click="
                                state.currentPage = 1;
                                getList();
                            "
                            style="margin-left: 4px"
                        >
                            <img src="img/search_btn.png" alt="검색" />
                        </button>
                    </div>
                </template>
            </div>
        </div>
        <div class="sign_form custom_scroll">
            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 60px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 150px" />
                        <col style="width: 40px" />
                        <col style="width: 130px" />
                        <col style="width: 60px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th rowspan="2">번호</th>
                            <th rowspan="2">이름</th>
                            <th rowspan="2">닉네임</th>
                            <th rowspan="2">아이디</th>
                            <th rowspan="2">성별</th>
                            <th rowspan="2">전화번호</th>
                            <th rowspan="2">등록</th>
                        </tr>
                    </thead>
                    <tbody style="max-height: 600px; overflow-y: auto">
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="cnt">{{ CommonUtils.numberFormat((state.currentPage - 1) * state.perPage + (idx + 1)) }}</td>
                                <td>{{ item.memberVO.name }}</td>
                                <td>{{ item.nickname }}</td>
                                <td>{{ item.memberVO.id }}</td>
                                <td class="cnt p_5">{{ getGenderText(item.gender) }}</td>
                                <td class="cnt">{{ CommonUtils.convertPhoneNumReal(item.phone) }}</td>

                                <td class="cnt p_5">
                                    <button type="button" class="table_btn _blue" @click="showNicknameModal(item)">등록</button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="6">
                                <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.currentPage"
                :totalLength="state.totalLength"
                :perPage="state.perPage"
                @onPaging="handlePageChange"
            ></PageBtn>

            <!-- <hr /> -->
            <!-- <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">닫기</button>
            </div> -->
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="state.isShowModal = false"
        @callback=""
    ></ModalDefault>

    <ActionCitizenAddModal
        v-if="state.isShowNicknameModal"
        :data="state.selectCitizen"
        @close="state.isShowNicknameModal = false"
        @callback="callBackModal"
    ></ActionCitizenAddModal>
</template>

<script lang="ts">
    import {
        onMounted,
        reactive,
        ModalDefault,
        apiService,
        types,
        PageBtn,
        CommonUtils,
        ActionCitizenAddModal,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        props: {
            idx: { type: Number, default: 0 },
        },
        emits: ["close", "callback", "change"],
        components: { ModalDefault, PageBtn, ActionCitizenAddModal },
        setup(props: any, { emit }: any) {
            const state = reactive({
                groupIdx: 0 as number,

                isShowNicknameModal: false as boolean,
                isShowModal: false as boolean,

                selectCitizen: {} as types.ResMemberDetailVOForApi,
                list: [] as types.ResMemberDetailVOForApi[],
                currentPage: 1 as number,
                perPage: 10 as number,
                totalLength: 0 as number,

                isShowSearchType: false as boolean,
                detailTxt: "전체" as string,
                searchType: "" as string,
                searchText: "" as string,
            });

            const modal = reactive({
                title: "" as string,
                content: "" as string,
                tab: 0 as number,
            });

            const search_type_list = [
                { id: "all", key: "all", value: "전체" },
                { id: "1", key: "name", value: "이름" },
                { id: "2", key: "id", value: "아이디" },
                { id: "3", key: "gender", value: "성별" },
                { id: "4", key: "phone", value: "전화번호" },
            ];

            onMounted(() => {
                state.groupIdx = props.idx;
                getList();
            });

            const getList = async () => {
                const param = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    grade: 0,
                } as types.ReqUserForList;
                const res = await apiService.actionCitizen.memberList(state.groupIdx, param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                }
            };

            const closeModal = () => emit("close");

            const callBackModal = async (param: any) => {
                if (param.nickname) add(param.nickname);
            };

            const showNicknameModal = (item: types.ResMemberDetailVOForApi) => {
                state.isShowNicknameModal = true;
                state.selectCitizen = item;
            };

            const add = async (nickname: string) => {
                const param = { nickname };
                const res = await apiService.actionCitizen.add(state.groupIdx, state.selectCitizen.idx, param);
                if (res.returnCode === 0) {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "등록이 완료되었습니다.";
                    state.isShowModal = true;
                    state.isShowNicknameModal = false;
                    getList();

                    emit("change");
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getList();
            };

            const getGenderText = (param: string) => {
                switch (param) {
                    case "M":
                        return "남자";
                    case "F":
                        return "여자";
                    default:
                        return "기타";
                }
            };

            return {
                CommonUtils,
                props,
                state,
                modal,
                search_type_list,
                getList,
                closeModal,
                callBackModal,
                add,
                handlePageChange,
                getGenderText,
                showNicknameModal,
            };
        },
    };
</script>

<style scoped>
    .sch_condition_wrap {
        margin-bottom: 10px;
        display: flex;
        gap: 10px;
        justify-content: start;
    }

    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }

    .checkbox_wrap2 em {
        display: none;
    }

    .gender_select {
        width: 90px;
        border: 1px solid var(--border_col);
        border-radius: 5px;
        height: 35px;
        display: flex;
        align-items: center;
        height: 35px;

        padding: 0 10px;
        font-size: 15px;
        outline: none;
    }

    .gender_select option {
        color: #333;
        background-color: #fff;
        font-size: 14px;
        font-weight: 500;
    }

    .common_table thead tr {
        position: initial;
    }

    .blue_box._full .common_table {
        max-height: 100%;
    }

    .common_table.custom_scroll > table > thead {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: var(--th_color);
    }
</style>
